import { Link } from "react-router-dom";
import { MapPin, Clock, Calendar, Users, ArrowRight } from "lucide-react";

export default function VacancyCard({ v, onRecommend, publicMode = false, showShare = false, onShare }) {
  const isContinuous = v.service_type === "continuous";
  const chipCls = isContinuous ? "chip-green" : "chip-blue";
  const label = isContinuous ? "Serviço de Continuidade" : "Serviço Pontual";
  const dot = isContinuous ? "🟢" : "🔵";
  const remaining = Math.max((v.slots || 1) - (v.slots_filled || 0), 0);

  return (
    <div className="card-surface p-6 flex flex-col" data-testid={`vacancy-card-${v.id || v.share_code}`}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <span className={`chip ${chipCls}`} data-testid="vacancy-type-chip">{dot} {label}</span>
          <h3 className="font-heading text-2xl mt-3 text-[var(--ink)] leading-tight">{v.title}</h3>
        </div>
        {v.status === "closed" && <span className="chip chip-neutral">Fechada</span>}
      </div>

      <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-[var(--ink-soft)]">
        <div className="flex items-center gap-2"><MapPin className="w-4 h-4"/> {v.locality}</div>
        <div className="flex items-center gap-2"><Clock className="w-4 h-4"/> {v.schedule}</div>
        {v.hours && <div className="flex items-center gap-2"><Clock className="w-4 h-4"/> {v.hours}</div>}
        {v.start_date && <div className="flex items-center gap-2"><Calendar className="w-4 h-4"/> Início {v.start_date}</div>}
        <div className="flex items-center gap-2"><Users className="w-4 h-4"/> {remaining} vaga{remaining !== 1 ? "s" : ""}</div>
      </div>

      {isContinuous ? (
        <div className="mt-5 p-4 rounded-2xl bg-[rgba(45,90,39,0.08)] border border-[rgba(45,90,39,0.15)]">
          <div className="eyebrow !text-[var(--success)]">Remuneração média mensal</div>
          <div className="font-heading text-4xl text-[var(--success)] mt-1">{v.monthly_avg ? `${Number(v.monthly_avg).toFixed(0)} €` : "—"}<span className="text-base text-[var(--ink-soft)] ml-1">/mês</span></div>
        </div>
      ) : (
        <div className="mt-5 p-4 rounded-2xl bg-[rgba(59,113,151,0.08)] border border-[rgba(59,113,151,0.15)]">
          <div className="eyebrow !text-[var(--info)]">Valor total do serviço</div>
          <div className="font-heading text-4xl text-[var(--info)] mt-1">{v.total_value ? `${Number(v.total_value).toFixed(0)} €` : "—"}</div>
        </div>
      )}

      <p className="text-sm text-[var(--ink-soft)] mt-4 line-clamp-3">{v.requirements}</p>

      <div className="mt-auto pt-5 flex items-center justify-between gap-3">
        <div className="chip chip-terra">15 € · Cartão Dá</div>
        <div className="flex gap-2">
          {showShare && (
            <button onClick={() => onShare?.(v)} className="pill-btn pill-ghost !py-2 !px-3" data-testid={`share-btn-${v.id}`}>Partilhar</button>
          )}
          {v.status === "open" ? (
            publicMode ? (
              <Link to={`/register?returnTo=/v/${v.share_code}`} className="pill-btn pill-primary !py-2 !px-4">Recomendar <ArrowRight className="w-4 h-4"/></Link>
            ) : (
              <button onClick={() => onRecommend?.(v)} className="pill-btn pill-primary !py-2 !px-4" data-testid={`recommend-btn-${v.id}`}>
                Recomendar <ArrowRight className="w-4 h-4"/>
              </button>
            )
          ) : (
            <span className="chip chip-neutral">Deixou de aceitar recomendações</span>
          )}
        </div>
      </div>
    </div>
  );
}
